import { render } from "./TrainConfigLastUpdatedCell.vue?vue&type=template&id=4025bea5"
import script from "./TrainConfigLastUpdatedCell.vue?vue&type=script&lang=js"
export * from "./TrainConfigLastUpdatedCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__